<script setup lang="ts">
import { TriangleAlert } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="quark-browser-notice" role="note">
    <TriangleAlert class="quark-notice-icon" aria-hidden="true" />
    <div class="quark-notice-content">
      <strong class="quark-notice-title">{{ t('captureStall.quarkTitle') }}</strong>
      <p>{{ t('captureStall.quarkHint') }}</p>
    </div>
  </div>
</template>

<style scoped>
.quark-browser-notice { display: flex; align-items: flex-start; gap: .625rem; margin: .625rem 0; padding: .75rem .875rem; border: .0625rem solid color-mix(in srgb, var(--danger) 38%, var(--border)); border-inline-start: .25rem solid var(--danger); border-radius: var(--radius-control); background: color-mix(in srgb, var(--danger) 6%, var(--surface)); }
.quark-notice-icon { flex: none; width: 1.125rem; height: 1.125rem; margin-top: .125rem; color: var(--danger); }
.quark-notice-content { min-width: 0; overflow-wrap: anywhere; }
.quark-notice-title { display: block; color: var(--danger); font-size: var(--font-heading); font-weight: 750; line-height: 1.5; }
.quark-notice-content p { margin: .375rem 0 0; color: var(--text-strong); font-size: var(--font-body); line-height: 1.6; }
</style>
